import { combine, withContext } from 'react-hooks-combine'

import {
  histoyOfInWins,
  event,
  main,
  mainProfile,
  historyOfTransBene,
  historyOfTransSponsor,
} from 'routes/route.map'
import { StoreContext } from 'store/context'
import { get } from 'lodash/fp'
import MenuComponent from './component'

export default combine({
  hooks: [
    withContext('loggedEntity', StoreContext, get('auth.loggedEntity')),
    withContext('appConfig', StoreContext, ({ appConfig }) => appConfig),
  ],
  transformProps: ({ loggedEntity, className, appConfig }) => {
    const beneMenuItems = [
      {
        title: 'About Us',
        icon: 'info',
        path: `${main.index()}?direct=true`,
      },
      {
        title: 'Transactions History',
        icon: 'history',
        path: historyOfTransBene.index(),
      },
      {
        title: 'Profile',
        icon: 'profile',
        path: mainProfile.index(),
      },
    ]

    if (loggedEntity?.isBeneficiary) {
      return {
        className,
        items: beneMenuItems,
        appConfig,
      }
    }

    const sponsorMenuItems = [
      {
        title: 'About Us',
        icon: 'info',
        path: `${main.index()}?direct=true`,
      },
      {
        title: 'Transactions History',
        icon: 'history',
        path: historyOfTransSponsor.index(),
      },
      {
        title: 'Profile',
        icon: 'profile',
        path: mainProfile.index(),
      },
    ]

    if (loggedEntity?.isSponsor) {
      return {
        className,
        items: sponsorMenuItems,
        appConfig,
      }
    }

    const menuItems = [
      {
        title: 'About Us',
        icon: 'info',
        path: `${main.index()}?direct=true`,
      },
      {
        title: 'Events',
        icon: 'event',
        path: event.index(),
      },
      {
        title: 'History of InWins',
        icon: 'history',
        path: histoyOfInWins.index(),
      },
      {
        title: 'Profile',
        icon: 'profile',
        path: mainProfile.index(),
      },
    ]

    return {
      className,
      items: menuItems,
      appConfig,
    }
  },
})(MenuComponent)
